import { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import {useLocation, useNavigate} from "react-router-dom";
import DatePicker from "react-multi-date-picker";
import { SetPrintDataContext } from "../../Pages/index";

import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { ReactTabulator } from "react-tabulator";
import { toast } from "react-toastify";
import Loader from "../Loader";

export default function FormKpiBuilder(props) {

    const [value,setValue]=useState(null)


    const location = useLocation();
    const navigateTo = useNavigate();

    useEffect(() => {
        if (location.state) {
            setValue({
                id:location.state.value.id,
                hasKpiId:location.state.value.hasKpiId,
                kpiOptions:location.state.value.kpiOptions,
            })
        }
        // document.title = "تعریف KPI جدید";
    }, [location]);


    // return <> من اگر نیکم اگر بد تو  برو خود را باش</>

    const formDOM = useRef(null);
    const tableRefKPI = useRef(null);

    const [fromBack, setFromBack] = useState(0);
    const [tabulatorDataState, setTabulatorDataState] = useState([]);
    const [selectedRow, setSelectedRow] = useState();

    function rowClickHandler(e, row) {
        row.getTable().getSelectedRows().length === 0
            ? setSelectedRow()
            : setSelectedRow(row);
    }

    const [
        tabulatorDataStateToSendBackPlease,
        setTabulatorDataStateToSendBackPlease,
    ] = useState([]);

    const refNumber1 = useRef(null);
    const refNumber2 = useRef(null);

    const tableOptions = { layout: "fitDataTable", selectable: 1 };

    const tableColumns = [
        {
            title: "نام فیلد",
            field: "nameField",
        },
        {
            title: "ارسالی به بک",
            field: "nameFieldValue",
            visible: false,
        },
        {
            title: "نوع واکشی",
            field: "typeOfSelect",
        },
        {
            title: "نوع واکشی ارسالی به بک",
            field: "typeOfSelectValue",
            visible: false,
        },
    ];

    function deleteRowFromTable() {
        let rows = tableRefKPI.current.table.getSelectedRows();

        setSelectedRow();
        let tempDataTabulator = [];
        let tempDataTabulatorToSendBackPlease = [];

        let tempObject = {
            nameField: rows[0].getData().nameField,
            nameFieldValue: rows[0].getData().nameFieldValue,
            typeOfSelect: rows[0].getData().typeOfSelect,
            typeOfSelectValue: rows[0].getData().typeOfSelectValue,
        };
        tabulatorDataState.map((v) => {
            if (JSON.stringify(v) !== JSON.stringify(tempObject)) {
                tempDataTabulator.push({
                    nameField: v.nameField,
                    nameFieldValue: v.nameFieldValue,
                    typeOfSelect: v.typeOfSelect,
                    typeOfSelectValue: v.typeOfSelectValue,
                });
            }
        });
        setTabulatorDataState(tempDataTabulator);
    }

    const addRowPlease = () => {
        if (refNumber1.current.value === "") {
            toast.error("لطفا یک گزینه را در بخش فیلد انتخاب کنید");
            return;
        }
        if (refNumber2.current.value === "") {
            toast.error("لطفا یک گزینه را در بخش نوع واکشی انتخاب کنید");
            return;
        }

        let tempDataTabulator = [];

        let tableDataPlease = tableRefKPI.current.table.getData();

        let objectToAdd = {
            nameField:
            refNumber1.current.options[refNumber1.current.selectedIndex].text,
            nameFieldValue: refNumber1.current.value,
            typeOfSelect:
            refNumber2.current.options[refNumber2.current.selectedIndex].text,
            typeOfSelectValue: refNumber2.current.value,
        };

        if (tableDataPlease.length > 0) {
            tableDataPlease.map((v) => {
                // اگه تکراری بود میشه لطفا اجازه ندی به جدول اضافه بشه؟
                if (JSON.stringify(v) === JSON.stringify(objectToAdd)) {
                    toast.error("این مورد قبلا به جدول اضافه شده است.");
                    return;
                }
                tempDataTabulator.push({
                    nameField: v.nameField,
                    nameFieldValue: v.nameFieldValue,
                    typeOfSelect: v.typeOfSelect,
                    typeOfSelectValue: v.typeOfSelectValue,
                });
            });
            tempDataTabulator.push(objectToAdd);
        } else {
            tempDataTabulator.push(objectToAdd);
        }
        setTabulatorDataState(tempDataTabulator);
    };

    // let sendArrayKpiTicks = [];
    // let sendArrayselectedData = [];
    // const onclickHandlerFormKpi = (e) => {
    //     e.preventDefault();
    //     // please Empty Arrays
    //     sendArrayKpiTicks = [];
    //     sendArrayselectedData = [];
    //     // console.log(e);
    //     let elements = formDOM.current.getElementsByTagName('input');
    //     // import Data to sendArrayDATA
    //     for (let element of elements) {
    //         if (element.checked) {
    //             if (element.id == "today" || element.id == "inDate") {
    //                 continue;
    //             }
    //             // console.log(element.value);
    //             sendArrayKpiTicks.push(element.value);
    //         }
    //     }
    //     // import Data to sendArrayDATE
    //     for (let element of elements) {
    //         if (element.checked) {
    //             if (element.id === "today") {
    //                 sendArrayselectedData.push("today");
    //             }
    //             if (element.id === "inDate") {
    //                 sendArrayselectedData.push("inDate");
    //             }
    //         }
    //     }
    //     for (let element of elements) {
    //         if (sendArrayKpiTicks.includes("inDate")) {
    //             if (element.type === "text") {
    //                 sendArrayselectedData.push(element.value);
    //             }
    //         }
    //     }
    //     axios({
    //         method: "GET", url: `${localStorage.getItem("apiUrl")}/kprint/`, params: {
    //             // pkValue: primaryKey,
    //             invoice: hasKpiId,
    //             options: Object.assign({}, sendArrayselectedData),
    //             date: Object.assign({}, sendArrayKpiTicks)
    //         }, headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    //     })
    //         .then((response) => {
    //
    //             // توست رو نشون بده و تشکر کن
    //             // console.log(response.data);
    //         })
    //         .catch((error) => console.error(error));
    //
    //
    // };

    const [show, setShow] = useState(false);

    const radioButtonShowDateHandler = (e) => {
        const { name, value } = e.target;
        if (value === "today") {
            setShow(false);
        }
        if (value === "inDate") {
            setShow(true);
        }
    };

    const titleRef = useRef();
    const checkBoxRef = useRef();

    const sendFormDataToAliTaheri = () => {
        let titleToSend = titleRef.current.value;

        let indicators = [];
        let fetchs = [];

        // ok dear i wanna take the values of CheckBoxes
        let elements = checkBoxRef.current.getElementsByTagName("input");
        // import Data to indicators
        for (let element of elements) {
            if (element.checked) {
                indicators.push(element.value);
            }
        }
        // tabulator data to fetch Array
        let tabulatorData = tableRefKPI.current.table.getData();
        tabulatorData.forEach((item) => {
            fetchs.push({ enName: item.nameFieldValue, arg: item.typeOfSelectValue });
        });
        // import Data to sendArrayDATE
        // for (let element of elements) {
        //     if (element.checked) {
        //         if (element.id === "today") {
        //             sendArrayDate.push("today");
        //         }
        //         if (element.id === "inDate") {
        //             sendArrayDate.push("inDate");
        //         }
        //     }
        // }
        // for (let element of elements) {
        //     if (sendArrayDate.includes("inDate")) {
        //         if (element.type === "text") {
        //             sendArrayDate.push(element.value);
        //         }
        //     }
        // }

        // ورودی ها رو پر کرده یا نه؟
        if (titleToSend === "") {
            toast.error("لطفا یک عنوان وارد کنید.");
            return;
        }
        if (indicators.length < 1) {
            toast.error("فیلد های شاخص خالی هستند!");
            return;
        }
        if (fetchs.length < 1) {
            toast.error("فیلد های واکشی را پر کنید!");
            return;
        }
        const url = localStorage.getItem("apiUrl") + "/atprint/";
        const sendRequest = axios.post(
                url,
                {
                    id: value.id,
                    options: {
                        title: titleToSend,
                        indicator: indicators,
                        fetch: fetchs,
                        hasChart: 0,
                    },
                },
                {
                    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
                }
            )
            .then(({ data }) => {
                console.log(data);
                if (data.status) {
                    toast.success(data.message);
                    navigateTo(-1)
                } else {
                    toast.error(data.message);
                }
            })
            .catch((err) => {
                console.log(
                    typeof err.response !== "undefined"
                        ? err.response.data.message
                        : err.message
                );
                console.log(err.response.data.message);
                console.log(err.message);
                debugger
                let msg = typeof err.response !== "undefined"? err.response.data : err.message
                toast.error(msg);
            });
    };

    return value!==null ? (
            <div ref={formDOM} className={"p-5"} style={{ width: "auto",height:"88vh" , overflow:"scroll" }}>
                <h4>تعریف KPI جدید</h4>
                <hr/>
                <div className={"d-flex justify-content-center align-items-center"}>
                    <label htmlFor={"titleForKPI"} className={"mx-2"}>
                        <h5>عنوان</h5>
                    </label>
                    <input
                        id={"titleForKPI"}
                        ref={titleRef}
                        type="text"
                        className={" rounded form-control"}
                        style={{ "max-width": "300px" }}
                        placeholder="عنوان را وارد کنید"
                    />
                </div>

                <div className={"my-3"}>
                    <h5 className={"text-center my-3"} >فیلد یا فیلد های شاخص:</h5>

                    <div
                        className="row"
                        ref={checkBoxRef}
                    >
                        {value.kpiOptions.indicator.map((v) => (
                            <>
                                <div className={"col-2"}>
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        value={v.value}
                                        id={v.value}
                                    />
                                    <label className="form-check-label px-2 " htmlFor={v.value}>
                                        {v.label}
                                    </label>
                                </div>
                            </>
                        ))}
                    </div>
                </div>
                <div className={"text-center"}>
                    <h5 className={"my-3"}>فیلد یا فیلد های واکشی:</h5>
                    <div
                        className={"d-flex flex-column"}
                        style={{ "white-space": "nowrap" }}
                    >
                        <divabl
                            className={
                                "d-flex justify-content-center align-items-center text-center my-2"
                            }
                        >
                            <div className={"mx-3"}>
                                <label htmlFor={"refNumber1"}>فیلد</label>
                            </div>
                            <div>
                                <select
                                    id={"refNumber1"}
                                    ref={refNumber1}
                                    className="form-select"
                                >
                                    <option value="" hidden>
                                        انتخاب کنید
                                    </option>
                                    {value.kpiOptions.fetch.map((v) => (
                                        <>
                                            <option value={v.value}>{v.label} </option>
                                        </>
                                    ))}
                                </select>
                            </div>
                        </divabl>
                        <div
                            className={
                                "d-flex justify-content-center align-items-center text-center my-2"
                            }
                        >
                            <div className={"mx-3"}>
                                <label htmlFor={"refNumber2"}> نوع واکشی </label>
                            </div>
                            <div>
                                <select
                                    id={"refNumber2"}
                                    ref={refNumber2}
                                    className="form-select form-select"
                                    style={{ direction: "rtl" }}
                                >
                                    <option value="" hidden>
                                        انتخاب کنید
                                    </option>
                                    <option value={"MIN"}>کمترین</option>
                                    <option value={"MAX"}>بیشترین</option>
                                    <option value={"AVG"}>میانگین</option>
                                    <option value={"SUM"}>جمع</option>
                                    <option value={"COUNT"}>تعداد</option>
                                </select>
                            </div>
                        </div>
                        <div>
              <span
                  onClick={addRowPlease}
                  className={"btnCustom btnSubmit  my-2 "}
              >
                افزودن
              </span>
                        </div>
                    </div>
                </div>
                <div
                    className={"text-center mt-4  mx-auto my-0"}
                    style={{ width: "auto" }}
                >
                    <ReactTabulator
                        ref={tableRefKPI}
                        columns={tableColumns}
                        data={tabulatorDataState}
                        // dataChanged={(newData) => console.log('dataChanged', newData)}
                        options={tableOptions}
                        // style={{ height: "50vh" }}
                        events={{ rowClick: rowClickHandler }}
                    />
                    <div className={""}>
                        <button
                            onClick={deleteRowFromTable}
                            className={"btnCustom btnRed btn-sm my-4"}
                            disabled={selectedRow === undefined}
                        >
                            <h6>حذف ردیف</h6>
                        </button>
                    </div>
                </div>
                <div className={"text-center"}>
                    <button
                        onClick={sendFormDataToAliTaheri}
                        className={"btnCustom btnSubmit my-2"}
                        // disabled={selectedRow === undefined}
                    >
                        ثبت نهایی KPI
                    </button>
                </div>
            </div>
    ) : <Loader/>
}

